import React from 'react';
import { connect } from 'react-redux';
import { AnyAction, bindActionCreators, Dispatch } from 'redux';
import { AppState } from '../store/configureStore';
import { Col, Row, Navbar } from "react-bootstrap";
import { dcrActionCreators } from '../store/DCRStore';
import logo from '../skin/images/Wespath_C.png';
import { version, last_updated } from '../../package.json';


type TCMFooterProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;
const CMFooter = (props: TCMFooterProps) => {

    return (
        <>
            <Navbar className="px-5 mt-5 flex-column" id="footer" >
                <GlobalFooter />
            </Navbar>
        </>
    )
};

function mapStateToProps(state: AppState) {
    return {
        dcr: state.dcr,
    }
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators({ ...dcrActionCreators }, dispatch);
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CMFooter);


const GlobalFooter = () => {

    return (<>
        <Row className="justify-content-between w-100" >
            <Col className="col-12 col-md-2">
                <img src={logo} id="footerLogo" alt="logo" />
            </Col>
            <Col className="col-12 col-md-10 text-md-right mt-2">
                <div className="d-xs-block d-sm-inline">
                    <a href="https://www.wespath.org/about-wespath/terms-and-conditions" target="_blank" rel="noopener noreferrer" className="footerLink">Terms and Conditions</a>
                    <span className="mx-2 d-none d-sm-inline">|</span>
                </div>
                <div className="d-xs-block d-sm-inline">
                    <a href="https://www.wespath.org/about-wespath/privacy-policy" target="_blank" rel="noopener noreferrer" className="footerLink">Privacy Policy</a>
                    <span className="mx-2 d-none d-sm-inline">|</span>
                </div>
                <div className="d-xs-block d-sm-inline">
                    <a href="http://www.wespath.org/online-security/" target="_blank" rel="noopener noreferrer" className="footerLink">Security</a>
                </div>

                <p className="mt-2 mt-md-4 mb-0">
                    &copy; 2020 Wespath Benefits and Investments, a general agency of The United Methodist Church.
                </p>
                <p className="mt-0">
                    {version} ({last_updated})
                </p>
            </Col>
        </Row>
    </>);

}